module.exports = __webpack_public_path__ + "static/media/13.84d47ec4.png";